import {
  SELECT_STYLE,
  CHANGE_AUTH,
  WAY,
  SAVE_QUERY,
  GET_FACECHECKMOREQUERY_SWITCH,
  SAVE_FACECHECKMOREQUERY_CHANNEL,
  SAVE_LGOO
} from './actions';

const initialState = {
  selectStyle: '1', // tab 1 可退改 2 处理中 3 已退改
  ticketType: '', // 请求参数 0-代表处理中  1-代表已退改
  authenticated: 0, // -1未实名认证且不展示 0未实名认证 1实名认证
  urlQuery: {}, // 存储首次进入时所带的参数
  faceCheckSwitch: false,
  faceCheckChannel: false,
  logoList: []
};

export default function updateDetailReducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_STYLE:
      return Object.assign({}, state, {
        selectStyle: action.data,
        ticketType: action.data === '2' ? '0' : action.data === '3' ? '1' : '',
      });
    case CHANGE_AUTH:
      return Object.assign({}, state, {
        authenticated: action.data,
      });
    case WAY:
      return Object.assign({}, state, {
        way: action.data,
      });
    case SAVE_QUERY:
      const params = Object.assign({}, state.urlQuery, action.data);
      return Object.assign({}, state, {
        urlQuery: params,
      });
    case GET_FACECHECKMOREQUERY_SWITCH:
      return Object.assign({}, state, {
        faceCheckSwitch: action.data.isOpen == 'Y',
      });
    case SAVE_FACECHECKMOREQUERY_CHANNEL:
      console.log(action.data);
      return Object.assign({}, state, {
        faceCheckChannel: action.data,
      });
    case SAVE_LGOO:
      return Object.assign({}, state, {
        logoList: action.data ? action.data : [],
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/updateDetail/modules/updateDetail.js